function DashboardSection({ title, description, action, children }) {
  return (
    <section className="flex min-h-0 w-full flex-1 flex-col">
      <div className="mb-[clamp(0.35rem,1vh,0.75rem)] flex shrink-0 items-center justify-between gap-2">
        <div className="min-w-0">
          <h2 className="truncate text-[clamp(1.125rem,2.4vw,1.75rem)] font-bold leading-tight text-gray-950">{title}</h2>
          {description && (
            <p className="mt-1 text-sm leading-6 text-gray-700">{description}</p>
          )}
        </div>
        <div className="shrink-0">{action}</div>
      </div>
      {children}
    </section>
  );
}

export default DashboardSection;
